import React from 'react';
import { motion } from 'framer-motion';
import { Trophy, Users, Heart, Coins, Printer, Zap } from 'lucide-react';
export function TargetAudience() {
  const items = [{
    icon: <Heart className="w-6 h-6 text-wc-red" data-id="element-264" />,
    text: 'Sos fanático del fútbol y querés vivir el Mundial al máximo'
  }, {
    icon: <Users className="w-6 h-6 text-wc-blue" data-id="element-265" />,
    text: 'Tenés hijos y querés darles la experiencia de completar el álbum'
  }, {
    icon: <Trophy className="w-6 h-6 text-wc-yellow" data-id="element-266" />,
    text: 'Sos coleccionista y querés tener todos los mundiales en un solo lugar'
  }, {
    icon: <Coins className="w-6 h-6 text-green-500" data-id="element-267" />,
    text: 'No querés gastar fortunas en sobres repetidos e incompletos'
  }, {
    icon: <Printer className="w-6 h-6 text-gray-700" data-id="element-268" />,
    text: 'Tenés acceso a una impresora o a una copistería cerca'
  }, {
    icon: <Zap className="w-6 h-6 text-orange-500" data-id="element-269" />,
    text: 'Querés recibirlo hoy, sin esperar envíos ni stock'
  }];
  return <section className="py-20 bg-white" data-id="element-270">
      <div className="container mx-auto px-4 max-w-4xl" data-id="element-271">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center mb-12" data-id="element-272">
          <h2 className="text-4xl md:text-5xl text-wc-dark mb-4" data-id="element-273">
            🎯 PARA QUIÉN ES ESTE PACK
          </h2>
          <p className="text-xl text-gray-600" data-id="element-274">Este pack es para vos si...</p>
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-275">
          {items.map((item, idx) => <motion.div key={idx} initial={{
          opacity: 0,
          x: idx % 2 === 0 ? -20 : 20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: idx * 0.1
        }} className="flex items-center gap-4 p-6 bg-gray-50 rounded-2xl border border-gray-100 hover:shadow-md transition-shadow" data-id="element-276">
              <div className="bg-white p-3 rounded-full shadow-sm" data-id="element-277">
                {item.icon}
              </div>
              <span className="text-lg font-medium text-gray-800" data-id="element-278">
                {item.text}
              </span>
            </motion.div>)}
        </div>
      </div>
    </section>;
}